import { refreshToken } from './refreshToken'
import { unauthorizedCountWithLocalStorage } from '@/lib/unauthorizedCountWithLocalStorage'
import { localStorageClear } from '@/lib/localStorageClear'

export const apiGetNoneAuth = async (url: string) => {
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
    })

    const result = await res.json()

    return result
  } catch (error) {
    console.log({ error })
  }
}

export const apiGet = async (url: string) => {
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Authorization': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
    })

    const result = await res.json()

    if (res.status === 200) {
      unauthorizedCountWithLocalStorage({ initial: 1 })
    }

    if (res.status === 401) {
      const unAuthorizedCount = unauthorizedCountWithLocalStorage({})
      if (unAuthorizedCount >= 20) {
        // 20回以上なのは、ログインすると4回GETのメソッドが実行されて、5回目以降にログアウトしてほしいため
        const siteUrl =
          process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
            ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
            : `${process.env.NEXT_PUBLIC_SITEURL}`
        location.href = `${siteUrl}/`
        localStorageClear()
      } else {
        await refreshToken()
      }
      return
    }

    const currentUrl = window.location.href
    if (!currentUrl.includes('/500')) {
      if (res.status === 500) {
        const siteUrl =
          process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
            ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
            : `${process.env.NEXT_PUBLIC_SITEURL}`
        location.href = `${siteUrl}/500`
        return
      }
    }

    return result
  } catch (error) {
    console.log({ error })
  }
}

export const apiPost = async (url: string, body?: any) => {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
      body: JSON.stringify(body),
    })

    const result = await res.json()

    if (res.status === 401) {
      refreshToken()
      return
    }

    const currentUrl = window.location.href
    if (!currentUrl.includes('/500')) {
      if (res.status === 500) {
        const siteUrl =
          process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
            ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
            : `${process.env.NEXT_PUBLIC_SITEURL}`
        location.href = `${siteUrl}/500`
        return
      }
    }

    return result
  } catch (error) {
    console.log({ error })
  }
}

export const apiPostNoneBody = async (url: string) => {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
    })

    const result = await res.json()

    if (res.status === 401) {
      refreshToken()
      return
    }

    const currentUrl = window.location.href
    if (!currentUrl.includes('/500')) {
      if (res.status === 500) {
        const siteUrl =
          process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
            ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
            : `${process.env.NEXT_PUBLIC_SITEURL}`
        return
      }
    }

    return result
  } catch (error) {
    console.log(error)
  }
}

export const apiDelete = async (url: string) => {
  try {
    const res = await fetch(`${url}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Authorization': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`),
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
    })

    const result = await res.json()

    if (res.status === 401) {
      refreshToken()
      return
    }

    const currentUrl = window.location.href
    if (!currentUrl.includes('/500')) {
      if (res.status === 500) {
        const siteUrl =
          process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
            ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
            : `${process.env.NEXT_PUBLIC_SITEURL}`
        location.href = `${siteUrl}/500`
        return
      }
    }

    return result
  } catch (error) {
    console.log(error)
  }
}
